// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

require("bootstrap");
require("bootstrap-select");
require("javascripts/scripts.bundle");
require("javascripts/tooltip");
require("@fortawesome/fontawesome-free/js/all");
// require('@client-side-validations/client-side-validations');

require("packs/general");
require("packs/users");
require("packs/permissions");
require("packs/variables");
require("packs/notifications");
require("packs/procesos_entrega_recepcion");
require("packs/dismissals");
require("packs/validate_variables_initializer");
require("packs/submit_file");
require("packs/cocoon");

// Components with react
require("components/logbook_index");
require("components/role_permissions");

//Gem Cocoon
//require("jquery")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
//require.context('../../assets/images', true);
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
//var componentRequireContext = require.context("components", true);
//var ReactRailsUJS = require("react_ujs");
//ReactRailsUJS.useContext(componentRequireContext);
